/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventSummary } from './EventSummary';
import {
    EventSummaryFromJSON,
    EventSummaryFromJSONTyped,
    EventSummaryToJSON,
    EventSummaryToJSONTyped,
} from './EventSummary';
import type { EventAttraction } from './EventAttraction';
import {
    EventAttractionFromJSON,
    EventAttractionFromJSONTyped,
    EventAttractionToJSON,
    EventAttractionToJSONTyped,
} from './EventAttraction';

/**
 * 
 * @export
 * @interface EventSearchResponse
 */
export interface EventSearchResponse {
    /**
     * 
     * @type {Array<EventSummary>}
     * @memberof EventSearchResponse
     */
    events: Array<EventSummary>;
    /**
     * 
     * @type {number}
     * @memberof EventSearchResponse
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof EventSearchResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof EventSearchResponse
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof EventSearchResponse
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventSearchResponse
     */
    hasNextPage: boolean;
    /**
     * 
     * @type {EventAttraction}
     * @memberof EventSearchResponse
     */
    resolvedAttraction?: EventAttraction;
    /**
     * How much price information this response carries. "exact" means price_range holds real bounds; "rank_only" means the provider withheld values but the ordering is still exact, so price_rank is meaningful and no amount should be stated. Absent when the results are not price-ordered at all.
     * @type {string}
     * @memberof EventSearchResponse
     */
    pricePrecision?: EventSearchResponsePricePrecisionEnum;
    /**
     * How many events price_rank was computed against. Always state this alongside a rank: "5th cheapest" is meaningless without the set it ranks within, and the same ambiguity in excluded_count produced identical text for two different meanings.
     * @type {number}
     * @memberof EventSearchResponse
     */
    priceRankedTotal?: number;
    /**
     * How many events that matched this query were withheld locally because they were unavailable (cancelled or postponed) or duplicate listings. Events outside the requested local dates are not counted: they did not match, so they were not withheld. This is the signal for "more was seen than shown"; total_elements is not, because its meaning differs between the plain and date-filtered search paths.
     * @type {number}
     * @memberof EventSearchResponse
     */
    excludedCount?: number;
}


/**
 * @export
 */
export const EventSearchResponsePricePrecisionEnum = {
    Exact: 'exact',
    RankOnly: 'rank_only'
} as const;
export type EventSearchResponsePricePrecisionEnum = typeof EventSearchResponsePricePrecisionEnum[keyof typeof EventSearchResponsePricePrecisionEnum];


/**
 * Check if a given object implements the EventSearchResponse interface.
 */
export function instanceOfEventSearchResponse(value: object): value is EventSearchResponse {
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('pageNumber' in value) || value['pageNumber'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('hasNextPage' in value) || value['hasNextPage'] === undefined) return false;
    return true;
}

export function EventSearchResponseFromJSON(json: any): EventSearchResponse {
    return EventSearchResponseFromJSONTyped(json, false);
}

export function EventSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(EventSummaryFromJSON)),
        'pageNumber': json['page_number'],
        'pageSize': json['page_size'],
        'totalElements': json['total_elements'],
        'totalPages': json['total_pages'],
        'hasNextPage': json['has_next_page'],
        'resolvedAttraction': json['resolved_attraction'] == null ? undefined : EventAttractionFromJSON(json['resolved_attraction']),
        'pricePrecision': json['price_precision'] == null ? undefined : json['price_precision'],
        'priceRankedTotal': json['price_ranked_total'] == null ? undefined : json['price_ranked_total'],
        'excludedCount': json['excluded_count'] == null ? undefined : json['excluded_count'],
    };
}

export function EventSearchResponseToJSON(json: any): EventSearchResponse {
    return EventSearchResponseToJSONTyped(json, false);
}

export function EventSearchResponseToJSONTyped(value?: EventSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': ((value['events'] as Array<any>).map(EventSummaryToJSON)),
        'page_number': value['pageNumber'],
        'page_size': value['pageSize'],
        'total_elements': value['totalElements'],
        'total_pages': value['totalPages'],
        'has_next_page': value['hasNextPage'],
        'resolved_attraction': EventAttractionToJSON(value['resolvedAttraction']),
        'price_precision': value['pricePrecision'],
        'price_ranked_total': value['priceRankedTotal'],
        'excluded_count': value['excludedCount'],
    };
}

